var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCcLogoReverse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 237.397,
    height: 44.837,
    viewBox: "0 0 237.397 44.837",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "White",
    transform: "translate(-38.842 -143.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52920",
    "data-name": "Group 52920",
    transform: "translate(86.643 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52919",
    "data-name": "Group 52919",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52918",
    "data-name": "Group 52918",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49361",
    "data-name": "Path 49361",
    d: "M1.016-12.656a8.5,8.5,0,0,1,.946-4.1,6.594,6.594,0,0,1,2.664-2.687,8,8,0,0,1,3.926-.946,7.481,7.481,0,0,1,4.732,1.484,6.923,6.923,0,0,1,2.489,4.171h-4.9A2.369,2.369,0,0,0,8.47-16.465a2.422,2.422,0,0,0-2.021.993A4.572,4.572,0,0,0,5.7-12.656,4.6,4.6,0,0,0,6.449-9.84a2.427,2.427,0,0,0,2.021.981,2.366,2.366,0,0,0,2.407-1.729h4.9a7.017,7.017,0,0,1-2.5,4.148A7.4,7.4,0,0,1,8.552-4.932a8.059,8.059,0,0,1-3.926-.935,6.659,6.659,0,0,1-2.664-2.7A8.472,8.472,0,0,1,1.016-12.656Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52923",
    "data-name": "Group 52923",
    transform: "translate(101.271 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52922",
    "data-name": "Group 52922",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52921",
    "data-name": "Group 52921",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49362",
    "data-name": "Path 49362",
    d: "M8.774-4.932A8.325,8.325,0,0,1,4.8-5.867a6.962,6.962,0,0,1-2.781-2.7,8.054,8.054,0,0,1-1-4.09,8.053,8.053,0,0,1,1.017-4.09,6.926,6.926,0,0,1,2.8-2.7,8.335,8.335,0,0,1,3.984-.946,8.343,8.343,0,0,1,3.984.946,6.855,6.855,0,0,1,2.8,2.7,8,8,0,0,1,1.028,4.09A7.884,7.884,0,0,1,15.6-8.578,7.069,7.069,0,0,1,12.77-5.867,8.469,8.469,0,0,1,8.774-4.932Zm0-3.984a2.977,2.977,0,0,0,2.243-.97,3.832,3.832,0,0,0,.935-2.769,3.914,3.914,0,0,0-.911-2.781,2.916,2.916,0,0,0-2.22-.97,2.917,2.917,0,0,0-2.232.958A3.968,3.968,0,0,0,5.7-12.656a3.988,3.988,0,0,0,.876,2.769A2.827,2.827,0,0,0,8.774-8.916Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52926",
    "data-name": "Group 52926",
    transform: "translate(117.673 156.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52925",
    "data-name": "Group 52925",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52924",
    "data-name": "Group 52924",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49363",
    "data-name": "Path 49363",
    d: "M6.838-26.656V-6.723h-4.6V-26.656Zm0,0",
    transform: "translate(-2.234 26.656)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52929",
    "data-name": "Group 52929",
    transform: "translate(123.949 156.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52928",
    "data-name": "Group 52928",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52927",
    "data-name": "Group 52927",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49364",
    "data-name": "Path 49364",
    d: "M6.838-26.656V-6.723h-4.6V-26.656Zm0,0",
    transform: "translate(-2.234 26.656)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52932",
    "data-name": "Group 52932",
    transform: "translate(129.315 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52931",
    "data-name": "Group 52931",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52930",
    "data-name": "Group 52930",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49365",
    "data-name": "Path 49365",
    d: "M16.1-12.9a12.045,12.045,0,0,1-.082,1.344H5.6a3.14,3.14,0,0,0,.9,2.15,2.763,2.763,0,0,0,1.951.736,2.409,2.409,0,0,0,2.4-1.461H15.75a6.726,6.726,0,0,1-1.367,2.676A6.831,6.831,0,0,1,11.917-5.6a7.942,7.942,0,0,1-3.307.666,8.121,8.121,0,0,1-3.938-.935,6.733,6.733,0,0,1-2.687-2.7,8.285,8.285,0,0,1-.97-4.09,8.5,8.5,0,0,1,.946-4.1,6.586,6.586,0,0,1,2.676-2.687,8.135,8.135,0,0,1,3.973-.946,8.007,8.007,0,0,1,3.879.923,6.6,6.6,0,0,1,2.652,2.606A7.938,7.938,0,0,1,16.1-12.9ZM11.38-14.116A2.369,2.369,0,0,0,10.574-16a2.972,2.972,0,0,0-2.021-.7,2.912,2.912,0,0,0-1.951.678,2.941,2.941,0,0,0-.981,1.9Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52935",
    "data-name": "Group 52935",
    transform: "translate(144.239 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52934",
    "data-name": "Group 52934",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52933",
    "data-name": "Group 52933",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49366",
    "data-name": "Path 49366",
    d: "M7.641-20.391a5.8,5.8,0,0,1,2.781.643,4.722,4.722,0,0,1,1.846,1.694V-20.18h4.615V-5.166a8.379,8.379,0,0,1-.83,3.751,6.226,6.226,0,0,1-2.5,2.687,8.158,8.158,0,0,1-4.195.993A8.728,8.728,0,0,1,3.937.688a5.936,5.936,0,0,1-2.36-4.265H6.133A2.137,2.137,0,0,0,7.15-2.221a3.756,3.756,0,0,0,2,.5,3.093,3.093,0,0,0,2.267-.83,3.5,3.5,0,0,0,.853-2.617V-7.292A5.1,5.1,0,0,1,10.41-5.586a5.61,5.61,0,0,1-2.769.654,6.252,6.252,0,0,1-3.377-.946A6.612,6.612,0,0,1,1.88-8.6a9.149,9.149,0,0,1-.865-4.09,9.055,9.055,0,0,1,.865-4.066,6.492,6.492,0,0,1,2.384-2.687A6.252,6.252,0,0,1,7.641-20.391Zm4.627,7.735a3.77,3.77,0,0,0-.958-2.722,3.076,3.076,0,0,0-2.325-1,3.115,3.115,0,0,0-2.325.993,3.7,3.7,0,0,0-.958,2.7,3.835,3.835,0,0,0,.958,2.746,3.083,3.083,0,0,0,2.325,1,3.086,3.086,0,0,0,2.325-.993A3.789,3.789,0,0,0,12.268-12.656Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52938",
    "data-name": "Group 52938",
    transform: "translate(160.861 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52937",
    "data-name": "Group 52937",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52936",
    "data-name": "Group 52936",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49367",
    "data-name": "Path 49367",
    d: "M16.1-12.9a12.045,12.045,0,0,1-.082,1.344H5.6a3.14,3.14,0,0,0,.9,2.15,2.763,2.763,0,0,0,1.951.736,2.409,2.409,0,0,0,2.4-1.461H15.75a6.726,6.726,0,0,1-1.367,2.676A6.831,6.831,0,0,1,11.917-5.6a7.942,7.942,0,0,1-3.307.666,8.121,8.121,0,0,1-3.938-.935,6.733,6.733,0,0,1-2.687-2.7,8.285,8.285,0,0,1-.97-4.09,8.5,8.5,0,0,1,.946-4.1,6.586,6.586,0,0,1,2.676-2.687,8.135,8.135,0,0,1,3.973-.946,8.007,8.007,0,0,1,3.879.923,6.6,6.6,0,0,1,2.652,2.606A7.938,7.938,0,0,1,16.1-12.9ZM11.38-14.116A2.369,2.369,0,0,0,10.574-16a2.972,2.972,0,0,0-2.021-.7,2.912,2.912,0,0,0-1.951.678,2.941,2.941,0,0,0-.981,1.9Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52941",
    "data-name": "Group 52941",
    transform: "translate(179.827 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52940",
    "data-name": "Group 52940",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52939",
    "data-name": "Group 52939",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49368",
    "data-name": "Path 49368",
    d: "M1.016-12.656a8.5,8.5,0,0,1,.946-4.1,6.594,6.594,0,0,1,2.664-2.687,8,8,0,0,1,3.926-.946,7.481,7.481,0,0,1,4.732,1.484,6.923,6.923,0,0,1,2.489,4.171h-4.9A2.369,2.369,0,0,0,8.47-16.465a2.422,2.422,0,0,0-2.021.993A4.572,4.572,0,0,0,5.7-12.656,4.6,4.6,0,0,0,6.449-9.84a2.427,2.427,0,0,0,2.021.981,2.366,2.366,0,0,0,2.407-1.729h4.9a7.017,7.017,0,0,1-2.5,4.148A7.4,7.4,0,0,1,8.552-4.932a8.059,8.059,0,0,1-3.926-.935,6.659,6.659,0,0,1-2.664-2.7A8.472,8.472,0,0,1,1.016-12.656Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52944",
    "data-name": "Group 52944",
    transform: "translate(194.455 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52943",
    "data-name": "Group 52943",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52942",
    "data-name": "Group 52942",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49369",
    "data-name": "Path 49369",
    d: "M8.774-4.932A8.325,8.325,0,0,1,4.8-5.867a6.962,6.962,0,0,1-2.781-2.7,8.054,8.054,0,0,1-1-4.09,8.053,8.053,0,0,1,1.017-4.09,6.926,6.926,0,0,1,2.8-2.7,8.335,8.335,0,0,1,3.984-.946,8.343,8.343,0,0,1,3.984.946,6.855,6.855,0,0,1,2.8,2.7,8,8,0,0,1,1.028,4.09A7.884,7.884,0,0,1,15.6-8.578,7.069,7.069,0,0,1,12.77-5.867,8.469,8.469,0,0,1,8.774-4.932Zm0-3.984a2.977,2.977,0,0,0,2.243-.97,3.832,3.832,0,0,0,.935-2.769,3.914,3.914,0,0,0-.911-2.781,2.916,2.916,0,0,0-2.22-.97,2.917,2.917,0,0,0-2.232.958A3.968,3.968,0,0,0,5.7-12.656a3.988,3.988,0,0,0,.876,2.769A2.827,2.827,0,0,0,8.774-8.916Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52947",
    "data-name": "Group 52947",
    transform: "translate(210.857 161.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52946",
    "data-name": "Group 52946",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52945",
    "data-name": "Group 52945",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49370",
    "data-name": "Path 49370",
    d: "M11.4-20.328a5.452,5.452,0,0,1,4.218,1.718,6.659,6.659,0,0,1,1.577,4.7v8.787H12.61v-8.167a3.284,3.284,0,0,0-.783-2.337,2.737,2.737,0,0,0-2.1-.841,2.729,2.729,0,0,0-2.1.841,3.271,3.271,0,0,0-.783,2.337v8.167h-4.6V-20.165h4.6v2a4.947,4.947,0,0,1,1.881-1.577A6.009,6.009,0,0,1,11.4-20.328Zm0,0",
    transform: "translate(-2.234 20.328)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52950",
    "data-name": "Group 52950",
    transform: "translate(226.234 157.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52949",
    "data-name": "Group 52949",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52948",
    "data-name": "Group 52948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49371",
    "data-name": "Path 49371",
    d: "M10.238-10.207v3.9H7.9A5.746,5.746,0,0,1,3.987-7.532a5.059,5.059,0,0,1-1.4-4V-17.51H.75v-3.833H2.584V-25H7.2v3.657h3.015v3.833H7.2v6.029a1.311,1.311,0,0,0,.315.981,1.588,1.588,0,0,0,1.075.292Zm0,0",
    transform: "translate(-0.75 25)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52953",
    "data-name": "Group 52953",
    transform: "translate(235.699 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52952",
    "data-name": "Group 52952",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52951",
    "data-name": "Group 52951",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49372",
    "data-name": "Path 49372",
    d: "M1.016-12.691a9.055,9.055,0,0,1,.865-4.066,6.492,6.492,0,0,1,2.384-2.687,6.252,6.252,0,0,1,3.377-.946,5.8,5.8,0,0,1,2.781.643,4.722,4.722,0,0,1,1.846,1.694V-20.18h4.615V-5.142H12.268V-7.269A4.872,4.872,0,0,1,10.4-5.575a5.766,5.766,0,0,1-2.781.643,6.209,6.209,0,0,1-3.353-.946A6.612,6.612,0,0,1,1.88-8.6,9.149,9.149,0,0,1,1.016-12.691Zm11.252.035a3.77,3.77,0,0,0-.958-2.722,3.076,3.076,0,0,0-2.325-1,3.115,3.115,0,0,0-2.325.993,3.7,3.7,0,0,0-.958,2.7,3.835,3.835,0,0,0,.958,2.746,3.083,3.083,0,0,0,2.325,1,3.086,3.086,0,0,0,2.325-.993A3.789,3.789,0,0,0,12.268-12.656Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52956",
    "data-name": "Group 52956",
    transform: "translate(252.321 161.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52955",
    "data-name": "Group 52955",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52954",
    "data-name": "Group 52954",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49373",
    "data-name": "Path 49373",
    d: "M1.016-12.656a8.5,8.5,0,0,1,.946-4.1,6.594,6.594,0,0,1,2.664-2.687,8,8,0,0,1,3.926-.946,7.481,7.481,0,0,1,4.732,1.484,6.923,6.923,0,0,1,2.489,4.171h-4.9A2.369,2.369,0,0,0,8.47-16.465a2.422,2.422,0,0,0-2.021.993A4.572,4.572,0,0,0,5.7-12.656,4.6,4.6,0,0,0,6.449-9.84a2.427,2.427,0,0,0,2.021.981,2.366,2.366,0,0,0,2.407-1.729h4.9a7.017,7.017,0,0,1-2.5,4.148A7.4,7.4,0,0,1,8.552-4.932a8.059,8.059,0,0,1-3.926-.935,6.659,6.659,0,0,1-2.664-2.7A8.472,8.472,0,0,1,1.016-12.656Zm0,0",
    transform: "translate(-1.016 20.391)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52959",
    "data-name": "Group 52959",
    transform: "translate(266.751 157.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52958",
    "data-name": "Group 52958",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52957",
    "data-name": "Group 52957"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49374",
    "data-name": "Path 49374",
    d: "M10.238-10.207v3.9H7.9A5.746,5.746,0,0,1,3.987-7.532a5.059,5.059,0,0,1-1.4-4V-17.51H.75v-3.833H2.584V-25H7.2v3.657h3.015v3.833H7.2v6.029a1.311,1.311,0,0,0,.315.981,1.588,1.588,0,0,0,1.075.292Zm0,0",
    transform: "translate(-0.75 25)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52962",
    "data-name": "Group 52962",
    transform: "translate(52.4 143.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52961",
    "data-name": "Group 52961",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52960",
    "data-name": "Group 52960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49375",
    "data-name": "Path 49375",
    d: "M15.185,2.516a16.055,16.055,0,0,1,8.027,2.01,14.693,14.693,0,0,1,5.573,5.492,15.107,15.107,0,0,1,2.021,7.723,15.666,15.666,0,0,1-2.407,8.7,13.807,13.807,0,0,1-6.824,5.433V27.111a9.6,9.6,0,0,0,4.241-3.657A10.613,10.613,0,0,0,27.3,17.74,11.2,11.2,0,0,0,25.818,12,10.4,10.4,0,0,0,21.6,8.019a13.6,13.6,0,0,0-6.415-1.437A13.488,13.488,0,0,0,8.817,8.019,10.471,10.471,0,0,0,4.587,12,11.174,11.174,0,0,0,3.1,17.74a10.709,10.709,0,0,0,1.461,5.714,9.505,9.505,0,0,0,4.23,3.657v4.767A13.683,13.683,0,0,1,2.04,26.445a15.772,15.772,0,0,1-2.384-8.7,15.285,15.285,0,0,1,1.986-7.723A14.547,14.547,0,0,1,7.169,4.525,15.972,15.972,0,0,1,15.185,2.516Zm0,0",
    transform: "translate(0.344 -2.516)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_52965",
    "data-name": "Group 52965",
    transform: "translate(38.842 158.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52964",
    "data-name": "Group 52964",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_52963",
    "data-name": "Group 52963",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49376",
    "data-name": "Path 49376",
    d: "M-25.69-12.418a16.055,16.055,0,0,1-8.027-2.01,14.693,14.693,0,0,1-5.573-5.492,15.107,15.107,0,0,1-2.021-7.723,15.666,15.666,0,0,1,2.407-8.7,13.807,13.807,0,0,1,6.824-5.433v4.767a9.6,9.6,0,0,0-4.241,3.657,10.613,10.613,0,0,0-1.484,5.714,11.2,11.2,0,0,0,1.484,5.737,10.4,10.4,0,0,0,4.218,3.984,13.6,13.6,0,0,0,6.415,1.437,13.488,13.488,0,0,0,6.368-1.437,10.471,10.471,0,0,0,4.23-3.984,11.174,11.174,0,0,0,1.484-5.737,10.709,10.709,0,0,0-1.461-5.714,9.505,9.505,0,0,0-4.23-3.657v-4.767a13.683,13.683,0,0,1,6.754,5.433,15.772,15.772,0,0,1,2.384,8.7,15.285,15.285,0,0,1-1.986,7.723,14.547,14.547,0,0,1-5.527,5.492A15.972,15.972,0,0,1-25.69-12.418Zm0,0",
    transform: "translate(41.312 41.781)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcLogoReverse);
export default __webpack_public_path__ + "static/media/CC-Logo-reverse.32379656902d9de221f664eca7238681.svg";
export { ForwardRef as ReactComponent };